"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreBubbleChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var BaseChart_1 = require("../_base/BaseChart");
var CoreBubbleChart = /** @class */ (function (_super) {
    tslib_1.__extends(CoreBubbleChart, _super);
    function CoreBubbleChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreBubbleChart.prototype.render = function () {
        return react_1.default.createElement(BaseChart_1.BaseChart, tslib_1.__assign({ type: "bubble" }, this.props));
    };
    return CoreBubbleChart;
}(react_1.default.Component));
exports.CoreBubbleChart = CoreBubbleChart;
//# sourceMappingURL=CoreBubbleChart.js.map